export default {
      id: "CNY-usage",
      viewBox: "0 0 372 401.3",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#CNY",
      toString: function () {
        return this.url;
      }
    }